import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import moment from 'moment';
import { Info } from '@mui/icons-material';
import { ILightZone } from '../../../../../types/Lights/lightZoneInterfaces';
import { StyledStatusLightsZonesButton } from './statusLightsZonesStyles';
import Strings from '../../../../../i18n';
import {
  LIGHT_STATUS_VALUES,
  LIGHT_STATUS_VALUES_STRING
} from '../../../../../constants/commonEnums';
import { JsonViewItem } from '../../../../../components/commons/JsonViewItem/jsonViewItem';

export const StatusLightsZones = ({ lightZone }: { lightZone: ILightZone }) => {
  const [visible, setVisible] = useState(false);
  const [valuesList, setValuesList] = useState<
    { title: string; value: string }[]
  >([]);

  const getLightStatusString = (lightStatusId: number) => {
    if (!lightStatusId || lightStatusId === LIGHT_STATUS_VALUES.OFF) {
      return 'Off';
    }
    return `On (${LIGHT_STATUS_VALUES_STRING[lightStatusId]})`;
  };

  useEffect(() => {
    const normalizedBrightnessId =
      lightZone.lightBrightnessId && lightZone.lightBrightnessId > 10
        ? Math.floor(lightZone.lightBrightnessId / 10)
        : lightZone.lightBrightnessId || 0;
    setValuesList([
      {
        title: 'Online / Offline',
        value: lightZone.isConnected ? 'Online' : 'Offline'
      },
      {
        title: 'Brightness',
        value: `${normalizedBrightnessId.toString()}${
          normalizedBrightnessId > 0 ? '0%' : '%'
        }`
      },
      {
        title: 'On / Off',
        value: getLightStatusString(lightZone.lightingStatusId)
      },
      {
        title: 'Change Reason',
        value: lightZone.changeReason
      },
      {
        title: 'Last Updated',
        value: moment(lightZone.lastUpdated).format('DD/MM/YYYY HH:mm:ss')
      },
      {
        title: 'Type',
        value: lightZone.typeName
      },
      {
        title: 'Controller',
        value: `${lightZone.controllerName} (${lightZone.controllerTypeName})`
      },

      ...(lightZone.patternSpeed !== undefined
        ? [
            {
              title: 'Rate / Period',
              value: `${lightZone.patternSpeed}`
            }
          ]
        : [])
    ]);
  }, [lightZone]);

  return (
    <>
      <StyledStatusLightsZonesButton onClick={() => setVisible(true)}>
        <Info />
      </StyledStatusLightsZonesButton>
      <Dialog
        header={`${Strings.common.status} ${lightZone.name}`}
        visible={visible}
        onHide={() => setVisible(false)}
        style={{ width: '50vw' }}
        breakpoints={{ '960px': '75vw', '641px': '95vw' }}
      >
        {valuesList.map((value) => {
          return (
            <div key={value.title}>
              <JsonViewItem title={value.title} values={value.value} />
            </div>
          );
        })}
      </Dialog>
    </>
  );
};
